import axios from 'axios'
import { The, createJsonData, createFormData } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'

// // #region CATEGORY

const workspace = getCurrentWorkspace()

export const category = {
  create: (formObj) =>
    The(
      axios.post(
        `${APIURL}/v4/categories/`,
        createFormData(formObj),
        config({ workspace })
      )
    ),

  getAll: (params = {}) =>
    The(axios.get(`${APIURL}/v4/categories/`, config({ workspace, params }))),

  getAllSubs: (parentSlug, params = {}) =>
    The(
      axios.get(
        `${APIURL}/v4/categories/${parentSlug}/`,
        config({ workspace, params })
      )
    ),

  getBreadcrumb: (catSlug) =>
    The(
      axios.get(
        `${APIURL}/v4/categories/${catSlug}/breadcrumb/`,
        config({ workspace })
      )
    ),

  addUser: (formObj) =>
    The(
      axios.post(
        `${APIURL}/v4/category-users/`,
        createJsonData(formObj),
        config({ contentType: HTTP.ContentTypes.JSON, workspace })
      )
    ),

  getUsers: (catSlug, params = {}) =>
    The(
      axios.get(
        `${APIURL}/v4/categories/${catSlug}/users/`,
        config({ params, workspace })
      )
    ),

  deleteUser: (userSlug) =>
    The(
      axios.delete(
        `${APIURL}/v4/category-users/${userSlug}/`,
        config({ workspace })
      )
    ),

  delete: (categorySlug) =>
    The(
      axios.delete(
        `${APIURL}/v4/categories/${categorySlug}/`,
        config({ workspace })
      )
    ),

  edit: (categorySlug, formObj, formParam = {}) =>
    The(
      axios.patch(
        `${APIURL}/v4/categories/${categorySlug}/`,
        createJsonData(formObj, { ...formParam }),
        config({ contentType: HTTP.ContentTypes.JSON, workspace })
      )
    ),
}

// #endregion CATEGORY
